module.exports = __webpack_public_path__ + "static/media/about-design.4daafd88.svg";